import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import { FiEye } from 'react-icons/fi';
import { useFundRequestContext } from '~/context/FundRequestProvider';
import { toUSD } from '~/utils';
import { fetchFundRequestHistoricalExpenses } from '~/services/fund-requests';

type HistoricalExpenseRequest = {
    id: number;
    ap_invoice_number: string | null;
    vendor_name: string | null;
    amount: string | null;
    description: string | null;
    updated_date: string;
    payment_type: string | null;
    status: string | null;
};

const HistoricalExpenses = () => {
    const { fundRequest } = useFundRequestContext();

    const {
        data: expenses,
        isLoading,
        isError,
        error,
    } = useQuery({
        queryKey: [
            'historicalExpenses',
            fundRequest.fund_info?.patient?.cf_patient_ntaf_id,
        ],
        queryFn: async () => {
            const resp = await fetchFundRequestHistoricalExpenses(
                fundRequest.fund_info?.patient?.cf_patient_ntaf_id
            );
            return resp;
        },
        enabled: !!fundRequest.fund_info?.patient?.cf_patient_ntaf_id,
    });

    if (isLoading) {
        return <div>Loading...</div>;
    }
    if (isError) {
        return <div>Error getting historical expenses: {error.message}</div>;
    }

    return (
        <>
            <div className='mb-4 flex items-center justify-between'>
                <h2 className='text-2xl font-bold'>Historical Expenses</h2>
                {/* <button className='flex items-center gap-2 font-medium text-primary'>
                    <FiSliders />
                    FILTERS
                </button> */}
            </div>

            <table className='w-full'>
                <thead>
                    <tr>
                        <th className='text-left text-[12px] font-normal'>
                            Payee
                        </th>
                        <th className='text-left text-[12px] font-normal'>
                            Invoice Number
                        </th>
                        <th className='text-left text-[12px] font-normal'>
                            Amount
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {expenses?.map((request: HistoricalExpenseRequest) => (
                        <tr key={request.id}>
                            <td className='py-2'>
                                <div className='flex flex-col'>
                                    <div className='text-sm text-gray-5'>
                                        {moment(request.updated_date).format(
                                            'MM/DD/YYYY'
                                        )}
                                    </div>
                                    <div>{request.vendor_name || 'N/A'}</div>
                                </div>
                            </td>
                            <td className='py-2'>{request.ap_invoice_number || 'N/A'}</td>
                            <td className='py-2'>{toUSD(Number(request.amount || 0))}</td>
                            <td className='py-2'>
                                <button>
                                    <FiEye className='text-primary' size={20} />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};

export default HistoricalExpenses;
